import type { ReactNode } from 'react'

import {
  AppShell,
  AppShellBody,
  AppShellContent,
  SidebarPortalProvider,
  Stack,
  StackItem,
} from '../../core'
import { useAppShellOverflowScroll } from '../hooks/useAppShellOverflowScroll'
import { GlobalAgentChatSidePanel } from './ask-ai/GlobalAgentChatSidePanel'

export interface JoyfulWebAppLayoutProps {
  children: ReactNode
  header: ReactNode
}

export function JoyfulWebAppLayout({
  children,
  header,
}: JoyfulWebAppLayoutProps) {
  const { contentRef, onScroll } = useAppShellOverflowScroll()

  return (
    <Stack direction="horizontal" width="full">
      <SidebarPortalProvider>
        <StackItem share="fill">
          <AppShell>
            {header}
            <AppShellBody className="overflow-hidden">
              <GlobalAgentChatSidePanel />
              <AppShellContent ref={contentRef} onScroll={onScroll}>
                {children}
              </AppShellContent>
            </AppShellBody>
          </AppShell>
        </StackItem>
      </SidebarPortalProvider>
    </Stack>
  )
}
